import type { ResourceProps } from 'react-admin';
import PercentIcon from '@mui/icons-material/Percent';

import ConditionDiscountsList from './ConditionDiscountsList';
import ConditionDiscountsCreate from './ConditionDiscountsCreate';
import ConditionDiscountsEdit from './ConditionDiscountsEdit';

export { conditionDiscountsDataProvider } from './dataProvider';

const resource: ResourceProps = {
  name: 'resalePricing/conditionDiscounts',
  list: ConditionDiscountsList,
  create: ConditionDiscountsCreate,
  edit: ConditionDiscountsEdit,
  icon: PercentIcon,
  options: { label: 'Condition Discounts' },
};

export default resource;
